import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const DeleteButtonSection = ({ gaEventCategory }) => {
  const onClick = () => {
    sendEvent({
      action: 'delete_account__button_config_page',
      category: gaEventCategory,
    });
  };

  return (
    <section>
      <Heading
        as="h2"
        className="text-neutral-low-100 dark:text-neutral-high-200"
        size="size3"
      >
        {placeholder('titles.disableAccount')}
      </Heading>
      <Heading
        as="h3"
        className="mb-4 mt-6 text-neutral-low-100 dark:text-neutral-high-200"
        size="size6"
      >
        {placeholder('titles.disableAccount')}
      </Heading>
      <NextLink href={LINKS.DELETE_ACCOUNT} prefetch={false} passHref>
        <Button
          as="a"
          rel="noreferrer"
          size="size3"
          type="error"
          onClick={onClick}
        >
          {placeholder('actions.disableAccount')}
        </Button>
      </NextLink>
    </section>
  );
};

DeleteButtonSection.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default DeleteButtonSection;
